/*
 * Author: LJH
 * Date: 2021/8/27
 * Description:
 */

import React, { useState, useRef } from 'react';
import { useUpdateEffect } from 'react-use';

function Collapse(props) {
  const el = useRef(null);
  const [height, setHeight] = useState(0);

  useUpdateEffect(() => {
    let H = 0;
    if (props.show) {
      H = el.current.offsetHeight;
    }
    setHeight(H);
  }, [props.show]);

  return (
    <div
      style={{
        height,
        transition: 'height 0.3s',
        overflow: 'hidden',
        ...props.style,
      }}
    >
      <div ref={el}>{props.children}</div>
    </div>
  );
}

export default Collapse;
